import i from "./index23.js";
import { resolveComponent as l, openBlock as t, createElementBlock as o, createVNode as n, createBlock as r, createCommentVNode as c, createElementVNode as m } from "vue";
import p from "../../../../_virtual/index.js";
const a = { class: "disclaimer" }, u = /* @__PURE__ */ m("br", null, null, -1);
function S(e, d, f, b, y, D) {
  const s = l("DisclaimerDesktop");
  return t(), o("div", a, [
    n(s, {
      isQuebec: e.isQuebec,
      isSimpleStyle: e.isSimpleStyle,
      showDefault: !0,
      settings: e.settings
    }, null, 8, ["isQuebec", "isSimpleStyle", "settings"]),
    u,
    e.isQuebec ? (t(), r(s, {
      key: 0,
      isQuebec: e.isQuebec,
      isSimpleStyle: e.isSimpleStyle,
      showDefault: !1,
      settings: e.settings
    }, null, 8, ["isQuebec", "isSimpleStyle", "settings"])) : c("", !0)
  ]);
}
const k = /* @__PURE__ */ p(i, [["render", S]]);
export {
  k as default
};
//# sourceMappingURL=index6.js.map
